import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=2ac10008&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=2ac10008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac10008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac10008')) {
      api.createRecord('2ac10008', component.options)
    } else {
      api.reload('2ac10008', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=2ac10008&scoped=true&", function () {
      api.rerender('2ac10008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DJzdC5HEaPRb/JS/comp/GuestBox.vue"
export default component.exports